import imgSanitizer from './img-sanitizer';

import type { PluggableList } from 'unified';

/**
 * Includes image URL whitelisting for additional security.
 */
export const REHYPE_PLUGINS: PluggableList = [imgSanitizer];
